<div *ngIf="isPageLoading" class="page-loader-overlay">
  <div class="loader-container">
    <!-- Animated dots -->
    <div class="dots-wrapper">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>

    <!-- Loading message -->
    <div class="loader-message">
      <span>{{ loadingMessage }}</span>
      <span class="loading-dots">...</span>
    </div>
  </div>
</div>

<div class="wrapper" *ngIf="userContext?.name && !isPageLoading">
  <aside id="sidebar" class="expand" *ngIf="userContext?.name">
    <!-- Logo Section -->
    <div class="logobox expanded d-flex justify-content-between">
      <div class="sidebar-logo p-0 justify-content-center">
        <div
          *ngIf="
            applicationData['logo'] && applicationData['logo'] !== 0;
            else fallbackAppLogo
          "
        >
          <a
            class="d-flex align-items-center justify-content-center"
            role="button"
          >
            <img
              src="{{ getDoc(applicationData['logo']) }}"
              class="user-img"
              alt="user avatar"
            />
            <p
              class="ps-2 mb-0 text-truncate fw-bold logo-app-name"
              title="Application Name"
            >
              {{ applicationData["name"] }}
            </p>
          </a>
        </div>
        <ng-template #fallbackAppLogo>
          <div class="sidebar-logo">
            <a routerLink="dashboard">
              <img
                [src]="
                  isTheme === 'darkmode' ||
                  isTheme === 'semidark' ||
                  isSidebarColored
                    ? 'assets/images/CDWhite.png'
                    : 'assets/images/CDBlack.png'
                "
                class="img-fluid"
                alt="Fallback Logo"
                title="{{ applicationData['name'] }}"
              />
            </a>
            <p
              class="ps-2 mb-0 text-truncate fw-bold logo-app-name"
              title="{{ applicationData['name'] }}"
              >
                {{ applicationData["name"] }}
            </p>
          </div>
        </ng-template>
      </div>
      <div class="toggle-btn float-end">
        <i class="bx bx-arrow-back"></i>
      </div>
    </div>
    <!-- Side Bar Menus -->
    <ul class="sidebar-nav" id="style-nav">
      <!-- Dashboard Menu-->
      <li class="sidebar-item">
        <a
          routerLink="dashboard"
          class="sidebar-link"
          routerLinkActive="active"
          title="Dashboard"
        >
          <i class="bi bi-house"></i>
          <span>{{ "app.Dashboard" | translate }}</span>
        </a>
      </li>

      <!-- Application Dashboard Menu -->
      <li *ngIf="accessList.length > 0" class="sidebar-item">
        <a
          routerLink="applicationdashboard"
          class="sidebar-link"
          routerLinkActive="active"
          title="Application Dashboard"
        >
          <i class="bi bi-grid"></i>
          <span>{{ "app.applicationdashboard" | translate }}</span>
        </a>
      </li>

      <li class="sidebar-item" *ngFor="let menu of menuItems">
        <app-menu-item [menu]="menu"></app-menu-item>
      </li>

      <hr />
    </ul>
  </aside>

  <div class="main">
    <nav
      class="navbar navbar-expand topbar expanded px-sm-4 px-1"
      *ngIf="userContext?.name"
    >
      <div class="d-flex">
        <div class="mobile-toggle-menu"><i class="bx bx-menu"></i></div>
        <form action="#" class="top-search">
          <div class="position-relative search-bar d-lg-block d-none">
            <input
              class="form-control px-5"
              type="search"
              placeholder="{{ 'COMMON.SEARCH' | translate }}"
              aria-describedby="basic-addon2"
              data-bs-toggle="modal"
              data-bs-target="#SearchModal"
              readonly
            />

            <span
              class="position-absolute top-50 search-show ms-3 translate-middle-y start-0 top-50 fs-5"
              data-bs-toggle="modal"
              data-bs-target="#SearchModal"
            >
              <i class="bx bx-search"></i>
            </span>
          </div>
        </form>
      </div>
      <ul
        class="navbar-nav d-flex justify-content-center align-items-center ms-auto mb-2 mb-lg-0"
      >
        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            routerLink="taskslist"
            matTooltip="{{ 'COMMON.TASKS' | translate }}"
            matTooltipPosition="above"
          >
            <i class="bi bi-check2-circle tasksicon"></i>
          </a>
        </li>

        <li class="nav-item dark-mode d-sm-flex">
          <a
            class="nav-link dark-mode-icon"
            href="javascript:;"
            (click)="toggleDarkModeFun()"
            [matTooltip]="isTheme == 'lightmode' ? 'Dark Mode' : 'Light Mode'"
          >
            <i
              [class]="isTheme == 'lightmode' ? 'bx bx-moon' : 'bx bx-sun'"
            ></i>
          </a>
        </li>

        <li class="nav-item" routerLinkActive="active">
          <a
            class="nav-link"
            routerLink="/chat"
            matTooltip="{{ 'Remains.CHAT' | translate }}"
            matTooltipPosition="above"
              >
            <i class="bx bx-chat tasksicon"></i>
          </a>
        </li>

        <li class="nav-item">
          <button
            mat-icon-button
            [matMenuTriggerFor]="langMenu"
            matTooltip="{{ 'Remains.Change_Language' | translate }}"
            matTooltipPosition="above"
            class="language-btn"
          >
            <mat-icon>translate</mat-icon>
          </button>

          <mat-menu #langMenu="matMenu" xPosition="before">
            <button
              mat-menu-item
              (click)="switchLanguage('en')"
              [class.bg-light]="currentLang === 'en'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >g_translate</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'en'"
                    [class.fw-bold]="currentLang === 'en'"
                    >English</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'en'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>

            <button
              mat-menu-item
              (click)="switchLanguage('hi')"
              [class.bg-light]="currentLang === 'hi'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >auto_stories</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'hi'"
                    [class.fw-bold]="currentLang === 'hi'"
                    >Hindi</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'hi'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>

            <button
              mat-menu-item
              (click)="switchLanguage('gu')"
              [class.bg-light]="currentLang === 'gu'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >history_edu</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'gu'"
                    [class.fw-bold]="currentLang === 'gu'"
                    >Gujarati</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'gu'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>

            <button
              mat-menu-item
              (click)="switchLanguage('ja')"
              [class.bg-light]="currentLang === 'ja'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >temple_buddhist</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'ja'"
                    [class.fw-bold]="currentLang === 'ja'"
                    >Japanese</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'ja'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>

            <button
              mat-menu-item
              (click)="switchLanguage('fr')"
              [class.bg-light]="currentLang === 'fr'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >flag</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'fr'"
                    [class.fw-bold]="currentLang === 'fr'"
                    >French</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'fr'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>

            <button
              mat-menu-item
              (click)="switchLanguage('es')"
              [class.bg-light]="currentLang === 'es'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >explicit</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'es'"
                    [class.fw-bold]="currentLang === 'es'"
                    >Spanish</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'es'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>

            <button
              mat-menu-item
              (click)="switchLanguage('ar')"
              [class.bg-light]="currentLang === 'ar'"
            >
              <div
                class="d-flex align-items-center justify-content-between w-100"
              >
                <div class="d-flex align-items-center">
                  <mat-icon class="me-3 text-secondary icon-compact"
                    >mosque</mat-icon
                  >
                  <span
                    [class.text-primary]="currentLang === 'ar'"
                    [class.fw-bold]="currentLang === 'ar'"
                    >Arabic</span
                  >
                </div>
                <mat-icon *ngIf="currentLang === 'ar'" class="ms-4 text-primary"
                  >check</mat-icon
                >
              </div>
            </button>
          </mat-menu>
        </li>
        <div class="user-box dropdown">
          <ul class="navbar-nav">
            <li class="nav-item dark-mode d-none d-sm-flex ms-1">
              <img
                src="{{ getDoc(userContext['orgLogoId']) }}"
                class="user-img"
                alt="user avatar"
                title="Org Image"
              />
            </li>
          </ul>

          <!-- <a
            class="d-flex align-items-center nav-link dropdown-toggle gap-3 dropdown-toggle-nocaret"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src="{{ getDocThumbnail(userContext['imageId']) }}"
              class="user-img"
              alt="user avatar"
              title="Profile"
            />
            <div class="user-info">
              <p class="user-name mb-0">{{ userContext["name"] }}</p>
              <p class="designattion mb-0">{{ userRole }}</p>
            </div>
          </a>

          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <a
                class="dropdown-item d-flex align-items-center"
                href="#"
                routerLink="myProfile"
              >
                <i class="bx bx-user fs-5"></i>
                <span>{{ "app.Profile" | translate }}</span>
              </a>
            </li>

            <li>
              <a
                class="dropdown-item d-flex align-items-center"
                href="#"
                routerLink="login/logout"
              >
                <i class="bx bx-log-out-circle"></i>
                <span>{{ "app.Logout" | translate }}</span>
              </a>
            </li>
          </ul> -->

          <!-- User Profile Button with Avatar and Info -->
          <button
            mat-button
            [matMenuTriggerFor]="userMenu"
            class="user-profile-btn"
          >
            <div class="d-flex align-items-center gap-3">
              <!-- User Avatar -->
              <img
                [src]="getDocThumbnail(userContext['imageId'])"
                class="user-img"
                alt="user avatar"
                title="Profile"
              />

              <!-- User Info -->
              <div class="user-info text-start">
                <p class="user-name mb-0">{{ userContext["name"] }}</p>
                <p class="designation mb-0">{{ userRole }}</p>
              </div>
            </div>
          </button>

          <!-- Material Menu -->
          <mat-menu
            #userMenu="matMenu"
            xPosition="before"
            class="user-profile-menu"
            yPosition="below"
          >
            <!-- Profile Option -->
            <button mat-menu-item routerLink="myProfile">
              <div class="d-flex align-items-center">
                <mat-icon>account_circle</mat-icon>
                <span>{{ "app.Profile" | translate }}</span>
              </div>
            </button>

            <mat-divider></mat-divider>

            <!-- Logout Option -->
            <button mat-menu-item routerLink="login/logout">
              <div class="d-flex align-items-center gap-1">
                <mat-icon>logout</mat-icon>
                <span>{{ "app.Logout" | translate }}</span>
              </div>
            </button>
          </mat-menu>
        </div>
      </ul>
    </nav>

    <main class="content expanded px-0 px-md-3 py-2" *ngIf="userContext?.name">
      <div class="container-fluid">
        <router-outlet></router-outlet>
      </div>
    </main>

    <footer class="page-footer expanded" *ngIf="userContext?.name">
      <p class="mb-0">{{ "app.footer" | translate: { year: currentYear } }}</p>
    </footer>

    <!--Start Back To Top Button-->
    <a href="javaScript:;" *ngIf="userContext?.name">
      <a
        href="javaScript:;"
        class="back-to-top"
        *ngIf="isBackToTopVisible"
        (click)="scrollToTop()"
        matTooltip="{{ 'Remains.Move_to_Top' | translate }}"
        matTooltipPosition="left"
        ><i class="bx bxs-up-arrow-alt"></i
      ></a>
    </a>
    <!--End Back To Top Button-->
  </div>
  <!-- <app-theme-customizer></app-theme-customizer> -->
</div>

<div class="wrapper" *ngIf="userContext['name'] == null && !isPageLoading">
  {{ userContext?.name }}
  <router-outlet></router-outlet>
</div>

<app-theme-customizer
  *ngIf="userContext['name'] != null"
></app-theme-customizer>

<!-- Modal  for Search -->
<div
  class="modal fixed-height-modal modal-body-fixed-height"
  id="SearchModal"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg rounded-4">
      <div class="modal-header gap-2 border-bottom-0 p-4 pb-2">
        <div class="position-relative popup-search w-100">
          <input
            class="form-control ps-5 border border-primary"
            id="search-text"
            type="search"
            placeholder="Search"
            aria-describedby="search-text"
            [(ngModel)]="inputsearchcontant"
            (blur)="clearInputSearch()"
            (input)="inputSearch($event)"
          />
          <i
            class="fa fa-eraser clear-icon position-absolute"
            *ngIf="inputsearchcontant"
            (click)="clearInputContant()"
            title="Clear"
          ></i>
          <span
            class="position-absolute top-50 search-show ms-3 translate-middle-y start-0 top-50 fs-5"
          >
            <i class="bx bx-search"></i>
          </span>
        </div>
        <button
          type="button"
          class="btn-close ms-3 align-self-center"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="clearInputContant()"
          matTooltip="{{ 'COMMON.CLOSE' | translate }}"
        ></button>
      </div>

      <div class="modal-body search-model-body p-4 pt-2">
        <div class="search-list">
          <div class="list-group">
            <ul
              *ngIf="menulist && menulist.length > 0"
              class="list-group list-group-flush border-1"
            >
              <li class="text-start list-group-item list-grop-heading">
                {{ "APPLICATIONS.MENU" | translate }}
              </li>

              <ng-container *ngFor="let item of menulist; let i = index">
                <li class="list-group-item border-0 px-0">
                  <a
                    [routerLink]="['uiformlist', item.Id]"
                    class="search-result-item d-flex align-items-center p-1 rounded-3 text-decoration-none transition-all"
                    (click)="clearInputContant()"
                    data-bs-dismiss="modal"
                  >
                    <div
                      class="search-icon-box rounded-circle bg-light d-flex align-items-center justify-content-center me-3"
                      style="width: 35px; height: 35px"
                    >
                      <i
                        [class]="item.icon || 'bx bx-layer'"
                        class="fs-5 text-primary"
                      ></i>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-0 fw-semibold">
                        {{ item.title }}
                      </h6>
                    </div>
                    <i class="bx bx-chevron-right fs-4 text-muted ms-auto"></i>
                  </a>
                </li>
              </ng-container>
            </ul>

            <ul
              *ngIf="reportlist && reportlist.length > 0"
              class="list-group list-group-flush border-1 mt-3"
            >
              <li class="text-start list-group-item list-grop-heading">
                {{ "APPLICATIONS.REPORTS" | translate }}
              </li>
              <ng-container *ngFor="let item of reportlist; let i = index">
                <li class="list-group-item border-0 px-0">
                  <a
                    [routerLink]="['reportslist', item.Id]"
                    class="search-result-item d-flex align-items-center p-1 rounded-3 text-decoration-none transition-all"
                    (click)="clearInputContant()"
                    data-bs-dismiss="modal"
                  >
                    <div
                      class="search-icon-box rounded-circle bg-light d-flex align-items-center justify-content-center me-3"
                      style="width: 35px; height: 35px"
                    >
                      <i
                        [class]="item.icon || 'bx bx-file'"
                        class="fs-5 text-primary"
                      ></i>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-0 fw-semibold">
                        {{ item.title }}
                      </h6>
                    </div>
                    <i class="bx bx-chevron-right fs-4 text-muted ms-auto"></i>
                  </a>
                </li>
              </ng-container>
            </ul>

            <ul
              *ngIf="urlList && urlList.length > 0"
              class="list-group list-group-flush border-1 mt-3"
            >
              <li class="text-start list-group-item list-grop-heading">URL</li>
              <ng-container *ngFor="let item of urlList; let i = index">
                <li class="list-group-item border-0 px-0">
                  <a
                    [href]="item.Id"
                    target="_blank"
                    class="search-result-item d-flex align-items-center p-1 rounded-3 text-decoration-none transition-all"
                    (click)="clearInputContant()"
                  >
                    <div
                      class="search-icon-box rounded-circle bg-light d-flex align-items-center justify-content-center me-3"
                      style="width: 35px; height: 35px"
                    >
                      <i class="bx bx-link-alt fs-5 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="mb-0 fw-semibold">
                        {{ item.title }}
                      </h6>
                    </div>
                    <i class="bx bx-external-link fs-4 text-muted ms-auto"></i>
                  </a>
                </li>
              </ng-container>
            </ul>

            <div
              class="text-center py-5"
              *ngIf="
                !menulist?.length &&
                !reportlist?.length &&
                !urlList?.length &&
                inputsearchcontant
              "
            >
              <div class="mb-3">
                <i class="bi bi-search text-light" style="font-size: 5rem"></i>
              </div>
              <h5 class="text-secondary">No matches found</h5>
              <p class="text-muted">Try searching for different keywords</p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal-footer border-top-1 bg-light p-2 justify-content-center rounded-bottom-4"
        *ngIf="
          (menulist && menulist.length > 0) ||
          (reportlist && reportlist.length > 0) ||
          (urlList && urlList.length > 0)
        "
      >
        <button
          mat-stroked-button
          color="warn"
          data-bs-dismiss="modal"
          type="button"
          (click)="clearInputContant()"
        >
          <mat-icon class="icon-compact">close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
